import { staffTypes } from "./../../types/userTypes";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Inject,
  Optional,
  OnInit
} from "@angular/core";
import {
  UntypedFormGroup,
  FormControl,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { CoreService } from "../../services/coreService";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

declare let toastr: any;

@Component({
    selector: "add-staff-modal",
    templateUrl: "./add-staff-modal.component.html",
    styleUrls: ["./add-staff-modal.component.scss"],
    standalone: true,
    imports: [ReactiveFormsModule]
})
export class AddStaffModalComponent implements OnChanges, OnInit {
  staffs: any;
  form: UntypedFormGroup;
  isSubmitted = false;
  user_types;
  showSusbcriptions=false;
  susbscription_types;
  @Input() parkingID = null;
  @Output() close = new EventEmitter();
  @Output() createStaff = new EventEmitter<any>();
  constructor(
    private builder: UntypedFormBuilder,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<AddStaffModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const { parkingID } = this.data;
    this.parkingID = parkingID;
    this.form = this.builder.group({
      parking_place_id: [this.parkingID, Validators.required],
      first_name: ["", Validators.required],
      last_name: ["", Validators.required],
      email: ["", Validators.compose([Validators.required, Validators.email])],
      mobileno: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("(^(\\+|0{2})\\d{12}$)|(^\\d{7,10}$)")
        ])
      ],
      user_type: ["", Validators.required],
      susbscription_type:[""],
      password: [
        "",
        Validators.compose([Validators.required, Validators.minLength(8)])
      ]
    });
  }

  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  resetModal() {
    this.form.reset();
    this.form.setValue({
      parking_place_id: this.parkingID,
      first_name: "",
      last_name: "",
      email: "",
      mobileno: "",
      user_type: "",
      susbscription_type:"",
      password: ""
    });
    this.isSubmitted = false;
  }

  submitForm() {
    console.log(this.form.value);
    this.isSubmitted = true;
    if (this.form.valid) {
      this.createStaff.emit(this.form.value);
      this.dialogRef.close(this.form.value);
      this.resetModal();
    } else {
      toastr.error("", "Form is invalid.", {
        timeOut: 2000
      });
    }
  }
  
  async ngOnInit() {
    try {
      this.user_types = await this.coreService
        .GetParkingPlaceRegConfig()
        .then(response => response.user_types);
    } catch (error) {
      toastr.error("", "Failed to fetch user types.", {
        timeOut: 2000
      });
    }
    try {
     this.susbscription_types = await this.coreService
        .GetParkingPlaceSuscription(this.parkingID)
        .then(response => response.data);
    } catch (error) {
      toastr.error("", "Failed to fetch Subscription types.", {
        timeOut: 2000
      });
      this.closeModal();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.parkingID.currentValue != null) {
      this.resetModal();
    }
  }

  userTypeChange()
  {
    if(this.form.value.user_type=='Tenant'){
      this.showSusbcriptions=true;
    }
    else{
      this.showSusbcriptions=false;
    }  
  }
}
